module.exports = __webpack_public_path__ + "media/customizations/verandaliving/back-8715216ab19fa2f4b866e0376a15035c.jpg";